import {
  deleteContractActivity,
  clearContractActivityAction,
} from 'actions/contracts/contractActivityActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractActivityDelete = ({
  formId,
  contractId,
  closeModal,
  selected,
}) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractActivityAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractActivity(selected, contractId))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract activity? This can not be
        undone.
      </div>
    </form>
  )
}

export default ContractActivityDelete
